<template>
    <div>
        <router-link key="collapse" class="sidebar-logo-link" to="/">
            <img src="~@/assets/images/logo-left.png" class="sidebar-logo__left">
            <img src="~@/assets/images/logo-right.png" class="sidebar-logo__right">
        </router-link>
        <el-scrollbar
            wrapClass="scrollbar-wrapper"
            style="height: 100%;border-right: 1px solid #cccccc;"
        >
            <el-menu
                mode="vertical"
                :show-timeout="200"
                :default-active="$route.uri"
                :collapse="isCollapse"
            >
                <sidebar-item
                    v-for="route in mune_routers"
                    :key="route.title"
                    :item="route"
                    :base-path="route.uri"
                ></sidebar-item>
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import SidebarItem from './SidebarItem';

export default {
    components: {SidebarItem},
    data() {
        return {
            mune_routers: []
        };
    },
    computed: {
        ...mapGetters(['sidebar']),
        isCollapse() {
            return !this.sidebar.opened;
        }
    },
    created() {
        this.$client.getCurrentUserSimpleMenus().then(ret => {
            this.mune_routers = ret.data || [];
        });
    }
};
</script>
<style lang="less" scoped>
.sidebar-logo-link {
    height: 50px;
    display: flex !important;
    background-color:#486DD5;
    box-sizing: border-box;
    .sidebar-logo__left {
        width: 30px;
        height:38px;
        padding: 4px;
        margin-left: 15px;
    }
    .sidebar-logo__right {
        margin: auto 12px;
        height: 40px;
        margin-left: 0px;
        height: 45px;

    }
}
</style>
